<template>
  <div class="prize">
    <template v-if="list.length > 0">
      <div class="list_item" v-for="(item, i) in list" :key="i">
        <div class="img">
          <img :src="item.picture" alt="" />
        </div>
        <div class="main">
          <div class="title">{{ item.activityPrizeName }}</div>
          <div class="date">{{ item.createDate }}</div>
        </div>
      </div>
    </template>
    <van-empty
      v-else
      class="custom-image"
      image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
      description="暂无奖品哦~"
    />
  </div>
</template>

<script>
import { getUserActivityWinner } from "@/api/draw.js";
export default {
  data() {
    return {
      list: [],
      activID: null,
      userInfo: null,
    };
  },
  created() {
    this.activID = this.$route.query.id;
    this.userInfo = JSON.parse(window.sessionStorage.getItem("loginInfo"));
    this.getList();
  },
  methods: {
    async getList() {
      const data = await getUserActivityWinner({
        activityId: this.activID,
        userId: this.userInfo.id,
      });
      console.log(data);
      if (data.code == 200) {
        this.list = data.data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .custom-image .van-empty__image {
  width: 90px;
  height: 90px;
}
div {
  box-sizing: border-box;
}
img {
  width: 100%;
  height: 100%;
}
.prize {
  width: 100%;
  height: 100%;
  padding: 10px 13px;
  background-color: #f6f6f6;
  .list_item {
    margin-top: 10px;
    width: 100%;
    border-radius: 8px;
    height: 111px;
    background-color: #fcfcfc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    .img {
      width: 120px;
      height: 80px;
      border-radius: 4px;
      overflow: hidden;
    }
    .main {
      margin-left: 13px;
      flex: 1;
      height: 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0;
      text-align: left;
      .title {
        width: 100%;
        text-align: left;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .date {
        width: 100%;
        text-align: left;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;
      }
    }
  }
}
</style>
<style>
.van-empty {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  transition: transform 0.3s;
}
.van-empty__description {
  width: 100%;
}
</style>
